import { Component, Prop, Vue, Watch } from 'vue-property-decorator';
import AboutMe from '../../shared/AboutMe/about.me.vue';
import PropertyDetail from '../../shared/PropertyDetail/property.detail.vue';
import Internationalizer from '../../shared/Internationalizer/internationalizer.vue';
import { CommonConfig } from '../../configs/config.common';
import { UserInfoDelegate } from '../../services/DataDelegate/UserInfoDelegate/user.info.delegate';
import SpinLoader from '../../shared/SpinLoader/spin.loader.vue';
import ShowingBook from '../../shared/ShowingBook/showing.book.vue';
import Banner from '../../shared/Banner/banner.vue';
import SocialShareComponent from '../../shared/SocialShare/social.share.vue';
import AgentFrontstoreStandardLayout from '../../layout/AgentFrontstoreStandardLayout/agent.frontstore.standard.layout.vue';
import EpicHeaderThreeRespnosive from '../../RifoDesign/EpicHeaderThreeRespnosive/epic.header.three.respnosive.vue';
import WwwShowingBook from '../../shared/WwwShowingBook/www.showing.book.vue';


@Component({
   components: {
      PropertyDetail,
      AboutMe,
      Internationalizer,
      SpinLoader,
      ShowingBook,
      SocialShareComponent,
      WwwShowingBook,
      'layout': AgentFrontstoreStandardLayout,
      EpicHeaderThreeRespnosive,
      Banner,
   }
})
export default class PropertyDetailPage extends Vue {
   public title: string = 'PropertyDetailPage';

   public id: string = '';

   public configs = new CommonConfig();

   public userInfoService = new UserInfoDelegate();

   public isLoading = false;

   @Watch('$store.state.propertyDetail.isFetching', { immediate: true, deep: true })
   public onLoading(val: any, oldVal: any) {
       this.isLoading = val;
   }

   public created() {
      this.id = this.$route.params.listingid;
   }
}
